// Intercepts any form inside a [data-newsletter-capture] wrapper and mirrors
// the email to the admin app's /api/newsletter endpoint alongside the normal
// Shopify submission. Language and source come from the wrapper's data-*
// attributes; we do not preventDefault, so Shopify customer creation still
// happens as before. Runs once on DOMContentLoaded.
(function () {
  function init() {
    var wrappers = document.querySelectorAll('[data-newsletter-capture]');
    if (!wrappers.length) return;

    wrappers.forEach(function (wrapper) {
      var url = wrapper.getAttribute('data-admin-api-url') || '';
      var key = wrapper.getAttribute('data-admin-api-key') || '';
      if (!url || !key) return;

      var source = wrapper.getAttribute('data-source') || 'unknown';
      var fallbackLang = wrapper.getAttribute('data-locale') || 'en';

      wrapper.querySelectorAll('form').forEach(function (form) {
        form.addEventListener('submit', function () {
          var emailInput = form.querySelector('input[type="email"], input[name="contact[email]"]');
          var email = emailInput && emailInput.value ? emailInput.value.trim() : '';
          if (!email) return;

          var lang = (window.Shopify && window.Shopify.locale) || fallbackLang;
          lang = lang === 'fr' ? 'fr' : 'en';

          try {
            fetch(url, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-API-Key': key,
              },
              body: JSON.stringify({
                email: email,
                language: lang,
                source: source,
                newsletter_subscribed: true,
              }),
              keepalive: true,
              mode: 'cors',
            }).catch(function () { /* swallow — Shopify submission is primary */ });
          } catch (_) { /* swallow */ }
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
